import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { SaveSearchQueryPayload, SearchProblem, SearchQuery, SearchResultsPayload } from 'src/app/state-management';
import { HandleError, HttpErrorHandler } from '../http-error-handler.service';


@Injectable()
export class SearchService {
  searchUrl = 'api/search';
  private handleError: HandleError;

  httpOptions = {
    headers: new HttpHeaders({
      'Cache-Control': 'no-cache',
      Pragma: 'no-cache'
    })
  };

  constructor(
    private httpClient: HttpClient,
    httpErrorHandler: HttpErrorHandler
  ) {
    this.handleError = httpErrorHandler.createHandleError('SearchService');
  }

  getSearchResults(payload: SearchResultsPayload): Observable<SearchProblem[]> {
    let params = new HttpParams();
    params = params.set('caseNumber', payload.caseNumber);
    params = params.set('description', payload.description);
    params = params.set('typeId', payload.typeId);
    params = params.set('subTypeId', payload.subTypeId);
    params = params.set('statusId', payload.statusId);
    params = params.set('sourceId', payload.sourceId);
    params = params.set('receivedFromId', payload.receivedFromId);
    params = params.set('groupId', payload.groupId);
    params = params.set('assigneeId', payload.assigneeId);
    params = params.set('contactId', payload.contactId);
    params = params.set('roleId', payload.roleId);
    params = params.set('reportedDateBegin', payload.reportedDateBegin);
    params = params.set('reportedDateEnd', payload.reportedDateEnd);
    params = params.set('completedDateBegin', payload.completedDateBegin);
    params = params.set('completedDateEnd', payload.completedDateEnd);
    params = params.set('location', payload.location);
    params = params.set('firstName', payload.firstName);
    params = params.set('lastName', payload.lastName);
    params = params.set('address', payload.address);
    params = params.set('phone', payload.phone);
    params = params.set('email', payload.email);
    params = params.set('priorityId', payload.priorityId);
    params = params.set('polygon', payload.polygon.toString());
    params = params.set('WorkOrderNumber', payload.workOrderNumber);
    return this.httpClient.get<SearchProblem[]>(this.searchUrl, { params: params, headers: this.httpOptions.headers });
  }

  addSearchQuery(searchQuery: SaveSearchQueryPayload): Observable<SaveSearchQueryPayload> {
    return this.httpClient.post<SaveSearchQueryPayload>( `${this.searchUrl}/savedSearches`, searchQuery )
      .pipe(
        catchError(this.handleError('addSearchQuery', null))
      );
  }

  getSearchQueries(): Observable<SearchQuery[]> {
    return this.httpClient.get<SearchQuery[]>(
      `${this.searchUrl}/savedSearches`, { headers: this.httpOptions.headers }
    );
  }

  deleteSavedSearchQuery(query: SearchQuery): Observable<SearchQuery> {
    return this.httpClient.delete<SearchQuery>(
      `${this.searchUrl}/savedSearches/${query.savedQuery_Id}`, {headers: this.httpOptions.headers }
    );
  }
}
